import React, { useState } from 'react';
import '../../entrydoor.css';

const Flex = ({ value, onChange, label = 'Flex' }) => {
    const [selectedFlex, setSelectedFlex] = useState(value || "");

    const handleFlexChange = (e) => {
        setSelectedFlex(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="Flex">{label}</label>
            <select
                id="Flex"
                value={selectedFlex}
                onChange={handleFlexChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Yes">{selectedFlex === "Yes" ? "Yes ✔" : "Yes"}</option>
                <option value="No">{selectedFlex === "No" ? "No ✔" : "No"}</option>
            </select>
        </div>
    );
};

export default Flex;
